export enum ActivityContentTypeEnum {
  scorm = "scorm",
  link = "link",
  video = "video",
}
